import SectionContentNavigation from './SectionContentNavigation';

export default SectionContentNavigation;
